export enum Permission {
  HOME = 'HOME',
  USERS = 'USERS',
  SUBSCRIBERS = 'SUBSCRIBERS',
  ACCESS_PLANS = 'ACCESS_PLANS',
  APPLICATION = 'APPLICATION',
  FINANCIAL = 'FINANCIAL',
  PARTNERS = 'PARTNERS',
  ACCESS_CONTROL = 'ACCESS_CONTROL',
  COMMUNICATION_CENTRAL = 'COMMUNICATION_CENTRAL',
}

export type PermissionType = {
  id: string;
  created_at: string;
  name: string;
  permissions: Record<Permission, boolean>;
};

export enum AccessControlUserStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
}

export type AccessControlUser = {
  id: string;
  created_at: string;
  name: string;
  document: string;
  email: string;
  phone_number: string;
  permission_type: PermissionType;
  last_access: string;
  status: AccessControlUserStatus;
};
